export const FAQ_CONSTANTS = {
    GET_FAQ_API: ':api/knowledge-base/faqs',
    GET_FAQ_API_WITH_SEARCH: ':api/knowledge-base/faqs/search',
    CREATE_FAQ_API: ':api/knowledge-base/faqs',
    UPDATE_FAQ_API: ':api/knowledge-base/faqs/{id}',
    DELETE_FAQ_API: ':api/knowledge-base/faqs/{id}',
};
